/*global getComputedStyle*/
import {observable, action, computed, runInAction} from 'mobx';
import autobind from 'autobind-decorator';

const DESKTOP_MIN_WIDTH = 800;

class ScreenState {
  @observable width;
  @observable height;
  @observable rem = 10;
  @observable headerOffset = 0;
  @observable isMenuAnimating = false;
  @observable reachedBottom = false;
  @observable supportsWebp = false;

  /*
   *  Used to track when a route is transitioning, for example, in the treatments and therapists
   *  list we use it to track route transition and hide elements in order to avoid issues with the
   *  auto page scroll to top when transitioning routes
   */
  @observable isRouteTransitioning = false;

  // Regex to detext mobile device on userAgent
  mobileDetectionRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

  @autobind @action resize() {
    this.width = window.innerWidth || document.body.clientWidth;
    this.height = window.innerHeight || document.body.clientHeight;
  }

  @computed get isDesktop() {
    return this.width >= DESKTOP_MIN_WIDTH;
  }

  constructor() {
    if (typeof window !== 'undefined') {
      if (window.addEventListener) {
        window.addEventListener('resize', this.resize);
        window.addEventListener('orientationchange', this.resize);
      } else if (window.attachEvent) {
        window.attachEvent('resize', this.resize);
        window.attachEvent('orientationchange', this.resize);
      }
      this.resize();
      runInAction(() => {
        this.rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
      });

      const webp = new window.Image();
      webp.onerror = () => {
        this.supportsWebp = false;
      };
      webp.onload = () => {
        this.supportsWebp = true;
      };
      webp.src = 'data:image/webp;base64,UklGRjIAAABXRUJQVlA4ICYAAACyAgCdASoBAAEALmk0mk0iIiIiIgBoSygABc6zbAAA/v56QAAAAA==';
    }
  }

  dispose() {
    if (typeof window !== 'undefined') {
      if (window.removeEventListener) {
        window.removeEventListener('resize', this.resize);
        window.removeEventListener('orientationchange', this.resize);
      } else if (window.detachEvent) {
        window.detachEvent('resize', this.resize);
        window.detachEvent('orientationchange', this.resize);
      }
    }
  }
}

export default ScreenState;



// WEBPACK FOOTER //
// ./spa/state/screen.jsx